import { IStatus } from '../measurement/InstrumentDetails';
import { ISampleDetails } from './SampleDetails';
interface IDirections {
    id: string;
    name: string
}
export interface IDirectionCounts {
    completedCounts: number;
    direction: IDirections;
    totalCounts: number
}

export interface IPositionCount {
    position: number;
    totalCounts: number;
    completedCounts: number
}

export interface ICount {
    completedCounts: number;
    totalCounts: number;
}

export interface IMeasurementProperties {
    id: string;
    name: string;
}



export interface IDirectionCountData {
    id: string;
    name: string;
    completedCounts: number;
    totalCounts: number;
}

export default interface IInstrumentSampleDetails {
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
    measurementId: string;
    orderId: string;
    sampleDate: string;
    setId: string;
    sampleDetails: ISampleDetails[],
    directions: IDirectionCountData[],
    instrumentStatus: IStatus
}

export class InstrumentSampleDetails implements IInstrumentSampleDetails {
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
    measurementId: string;
    orderId: string;
    sampleDate: string;
    setId: string;
    sampleDetails: ISampleDetails[];
    directions: IDirectionCountData[];
    instrumentStatus: IStatus;

    constructor(id: string, name: string, description: string, isEnabled: boolean, measurementId: string, orderId: string,
        sampleDate: string, setId: string, sampleDetails: ISampleDetails[], instrumentStatus: IStatus) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.isEnabled = isEnabled;
        this.measurementId = measurementId;
        this.orderId = orderId;
        this.sampleDate = sampleDate;
        this.setId = setId;
        this.sampleDetails = sampleDetails;
        this.directions = [];
        this.instrumentStatus = instrumentStatus;

        sampleDetails.forEach((x: any) => {
            x.directionCounts.forEach((counts: any) => {
                this.directions.push({
                    totalCounts: counts.totalCounts,
                    completedCounts: counts.completedCounts,
                    name: counts.direction.name,
                    id: counts.direction.id
                })
            })
        });
    }
}

const defaultInstrumentSampleDetailsData = new InstrumentSampleDetails("", "", "", false, "", "", "", "", [],null);
export { defaultInstrumentSampleDetailsData };